// @ts-nocheck
// Exact live (2026-10-15) version restored from the production sourcemap.
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from 'react/jsx-runtime';
import { useEffect, useState } from 'react';
import { Box, Grid } from '@mui/material';
import { ClipboardExport } from 'iconsax-react';
import { UserProfileCard } from './cards/UserProfile';
import { ProfileActionCard } from './ProfileAction';
import { CompanyInformationCard } from './cards/CompanyInformation';
import { PersonalInformationCard } from './cards/PeronsalInformation';
import { PageHeader } from '../../../components/common/header/PageHeader';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { getProfileAsync } from '@application/features/freelancer/freelancerThunks';
import { UserStatusMap } from '@application/common/enums/user-status';
import { getCountriesAsync } from '@application/features/country/countryThunk';
import { Loader } from '@ui/components/common/Loader';
import { getCurrentUserAsync } from '@application/features/adminUsers/adminUserThunk';
import { PayoutPreferenceSection } from './PayoutPreferenceSection';
import { ConnectedApps } from '../../connect/ConnectedApps';
export const MyProfile = () => {
    const { freelancerProfile } = useAppSelector((state) => state.freelancer);
    const { currentUser } = useAppSelector((state) => state.user);
    const [isLoading, setIsLoading] = useState(true);
    const [avatarImage, setAvatarImage] = useState(null);
    const dispatch = useAppDispatch();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    useEffect(() => {
        dispatch(getCurrentUserAsync(''));
        dispatch(getCountriesAsync());
        dispatch(getProfileAsync())
            .unwrap()
            .then((result) => {
            setAvatarImage(result.file);
            setIsLoading(false);
        })
            .catch(() => { });
    }, [dispatch, searchParams, avatarImage]);
    // Profile status is shown as a small badge next to the name (only when the API returned a known status).
    const profileStatus = UserStatusMap.get(freelancerProfile.status) ? freelancerProfile.status : undefined;
    return _jsxs(Box, {
        minHeight: '100%',
        children: [
            isLoading && _jsx(Loader, { isLoading: isLoading }),
            _jsxs(Box, {
                minHeight: '70%',
                children: [
                    _jsx(PageHeader, { title: 'My profile' }),
                    _jsxs(Box, {
                        display: 'flex',
                        flexDirection: 'column',
                        // alignItems={'flex-end'}
                        // justifyContent={'flex-end'}
                        minHeight: { xs: 'auto', sm: 'auto', md: 'auto', lg: 'calc(100svh - 300px)' },
                        padding: 2,
                        children: [
                            _jsxs(Grid, {
                                container: true,
                                spacing: 2,
                                children: [
                                    _jsx(Grid, {
                                        item: true,
                                        xs: 12,
                                        sm: 6,
                                        md: 6,
                                        lg: 2,
                                        xl: 2,
                                        children: _jsx(Box, {
                                            mb: { xs: 5, sm: 5, md: 5, lg: 0, xl: 0 },
                                            children: _jsx(UserProfileCard, { profilePicture: avatarImage, profileStatus: profileStatus })
                                        })
                                    }),
                                    _jsxs(Grid, {
                                        item: true,
                                        xs: 12,
                                        sm: 6,
                                        md: 6,
                                        lg: 2.4,
                                        xl: 2,
                                        // "Edit profile" moved to a small Edit button in the Personal information header (same route).
                                        children: [
                                            _jsx(ProfileActionCard, {
                                                subtitle: 'Invoices & Faqtoring',
                                                leftIcon: _jsx(ClipboardExport, {}),
                                                onClick: () => navigate('/invoicing')
                                            })
                                        ]
                                    }),
                                    currentUser
                                        ? currentUser.contractType === 'Seconded'
                                            ? _jsx(Grid, {
                                                item: true,
                                                xs: 12,
                                                sm: 12,
                                                md: 4,
                                                lg: 3.8,
                                                xl: 4,
                                                children: _jsx(PersonalInformationCard, {})
                                            })
                                            : _jsxs(_Fragment, {
                                                children: [
                                                    _jsx(Grid, {
                                                        item: true,
                                                        xs: 12,
                                                        sm: 12,
                                                        md: 4,
                                                        lg: 3.8,
                                                        xl: 4,
                                                        children: _jsx(PersonalInformationCard, {})
                                                    }),
                                                    _jsx(Grid, {
                                                        item: true,
                                                        xs: 12,
                                                        sm: 12,
                                                        md: 4,
                                                        lg: 3.8,
                                                        xl: 4,
                                                        children: _jsx(CompanyInformationCard, {})
                                                    })
                                                ]
                                            })
                                        : _jsx(_Fragment, {})
                                ]
                            }),
                            _jsx('br', {}),
                            currentUser &&
                                currentUser.contractType !== 'Seconded' &&
                                _jsx(Box, {
                                    mt: 3,
                                    p: 3,
                                    maxWidth: 760,
                                    bgcolor: '#fff',
                                    borderRadius: '25px',
                                    border: '1px solid #E6E6E6',
                                    children: _jsx(PayoutPreferenceSection, {})
                                }),
                            // Connected apps (add-qportal-mcp-connectors): renders nothing while the connectors are switched off.
                            _jsx(ConnectedApps, {
                                sx: { mt: 3, p: { xs: 2, sm: 3 }, maxWidth: 760, bgcolor: '#fff', borderRadius: '25px', border: '1px solid #E6E6E6', boxSizing: 'border-box' }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
